import getBasePath from '../functions/api-resource';
import empresa from '../functions/company';

const basePath = getBasePath('api', 'v1');

const pedidoActions = {
    guardar: { method: 'POST', url: `${basePath}/pedidos?conexion=${empresa}` },
    enviarMail: { method: 'POST', url: `${basePath}/pedidos/enviarMail?conexion=${empresa}` },
    guarda: { method: 'PUT', url: `${basePath}/pedidos/{idPedido}?conexion=${empresa}` },
    getPedido: { method: 'GET', url: `${basePath}/pedidos/{idPedido}?conexion=${empresa}` },
    getPedidosCliente: { method: 'GET', url: `${basePath}/pedidos/cliente/{idCliente}?conexion=${empresa}` },
    getFacturasCliente: { method: 'GET', url: `${basePath}/pedidos/facturascliente/{idCliente}?conexion=${empresa}` },
    buscarPagos: { method: 'GET', responseType: 'arraybuffer', url: `${basePath}/pedidos/{idPedido}/pagos?conexion=${empresa}` },
    pagos: { method: 'POST', url: `${basePath}/pedidos/{idPedido}/pagos?conexion=${empresa}` },
    abono: { method: 'POST', url: `${basePath}/pedidos/{idPedido}/pagos/abono?conexion=${empresa}` },
    postEnviosPedidos: { method: 'POST', url: `${basePath}/pedidos/{idPedido}/envios?conexion=${empresa}` },
    putSeguimiento: { method: 'PUT', url: `${basePath}/pedidos/{idSeguimiento}/seguimiento?conexion=${empresa}` },
    getXML: { method: 'GET', url: `https://archivos.stshop.mx/EJEMPLO2/CFD/AAA010101AAA_Cliente_V_F_CFDI_186.xml` },

};

export default resource => resource(`${basePath}`, {}, pedidoActions);


// WEBPACK FOOTER //
// ./src/common/resources/pedido.js